// import React, { useState } from 'react';
// import Carousel from "react-spring-3d-carousel";
// import { v4 as uuidv4 } from "uuid";
// import { config } from "react-spring";
// import '../css/aboutUs.css';



// const AboutUs = () => {
//   const [activeTab, setActiveTab] = useState("objectives");

//   const InCards = [
//     {
//       key: uuidv4(),
//       tab: "objectives",
//       title: "Objectives",
//       content: (
//         <div className="card objectives">
//           <ul>
//             <li>Practice, promote, and propagate the principles of the Universal Declaration of Human Rights.</li>
//             <li>Foster free and quality education among children.</li>
//             <li>Ensure the availability of basic necessities like food, shelter, and clothing to all Indians.</li>
//             <li>Fight against discrimination of humans based on sex, caste, creed, religion, and more.</li>
//             <li>Provide free legal aid to the needy people of India.</li>
//             <li>Create awareness among youth about their fundamental duties.</li>
//             <li>Rehabilitate direct and indirect victims of crime until they are financially and mentally restored to live a normal social life.</li>
//             <li>Publish books and periodicals to spread awareness and knowledge related to Human Rights.</li>
//           </ul>
//         </div>
//       )
//     },
//     {
//       key: uuidv4(),
//       tab: "vision",
//       title: "Vision Statement",
//       content: (
//         <div className="card vision">
//           <ul>
//             <li>Provision of health, education, and employment opportunities in registered slums of India and spread a green revolution among slums to upgrade them into more sophisticated and hygienic dwellings, supporting the United Nations Sustainable Development Programme.</li>
//             <li>Rehabilitation of victims of domestic violence, abandoned children, women, and elderly citizens.</li>
//             <li>Serve as an information provider to government bodies regarding anti-social activities, domestic violence, and corrupt practices.</li>
//             <li>Be instrumental in making permanent positive changes in society that enforce gender equality.</li>
//           </ul>
//         </div>
//       )
//     },
//     {
//       key: uuidv4(),
//       tab: "rules",
//       title: "Rules and Regulations",
//       content: (
//         <div className="card rules">
//           <ul>
//             <li>The unit/cell/committee are free to take up projects/programmes provided they adhere to the following guidelines:</li>
//             <ul>
//               <li>Programmes should not propagate religious or political viewpoints.</li>
//               <li>Programs must avoid anti-social or anti-government activities.</li>
//               <li>Unhealthy criticism of the government and its officials is not allowed.</li>
//               <li>Programs should align with the objectives of the National Human Rights Federation.</li>
//               <li>Cash donations for a specific programme must be used solely for that project.</li>
//               <li>A receipt voucher must be provided for all donations.</li>
//               <li>Receipt vouchers must be issued by the national committee.</li>
//               <li>General cash donations are not allowed.</li>
//               <li>Units must participate in national programmes when requested.</li>
//               <li>Programme proposals must be sanctioned by the national president before execution.</li>
//               <li>Half-yearly activity and financial reports must be submitted on time.</li>
//             </ul>
//             <li>Membership Rules:</li>
//             <ul>
//               <li>Membership applications must include a signed form, Aadhaar or PAN card photocopy, and two passport photos.</li>
//               <li>Membership fees should be credited to the Federation's account, with proof sent to the national committee.</li>
//               <li>Members wishing to form a unit must follow the hierarchy and submit the appropriate forms.</li>
//             </ul>
//           </ul>
//         </div>
//       )
//     },
//     {
//       key: uuidv4(),
//       tab: "mission",
//       title: "Mission Statement",
//       content: (
//         <div className="card mission">
//           <ul>
//             <li>Provision of nutritional food and medical facilities to the needy.</li>
//             <li>Provision of quality and free education to needy children.</li>
//             <li>Fight for the cause of the third gender.</li>
//           </ul>
//           <p>The mission statement shall be updated and modified with time.</p>
//         </div>
//       )
//     }
//   ];

//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//   };

//   return (
//     <div className="about-us-container">
//       <div className="tab-navigation">
//         {InCards.map((card) => (
//           <div
//             key={card.key}
//             className={`tab ${activeTab === card.tab ? "active" : ""}`}
//             onClick={() => handleTabChange(card.tab)}
//           >
//             {card.title}
//           </div>
//         ))}
//       </div>

//       <div className="tab-content">
//         {InCards
//           .filter((card) => card.tab === activeTab)
//           .map((card) => (
//             <div key={card.key}>{card.content}</div>
//           ))}
//       </div>
//     </div>
//   );
// };

// export default AboutUs;

import { useState,useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import '../css/aboutUs.css';

import certificate1 from '../assets/Certificates/1.jpg';
import certificate2 from '../assets/Certificates/2.jpg';
import certificate3 from '../assets/Certificates/3.jpg';
import certificate4 from '../assets/Certificates/4.jpg';
import certificate5 from '../assets/Certificates/5.jpg';
import certificate6 from '../assets/Certificates/6.jpg';
import { motion } from "framer-motion";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const AboutUs = () => {
  const [activeTab, setActiveTab] = useState("objectives");
  const [activeIndex, setActiveIndex] = useState(0);
  const InCards = [
    {
      key: uuidv4(),
      tab: "objectives",
      title: "Objectives",
      content: (
        <div className="card objectives">
          <ul>
            <li>Practice, promote, and propagate the principles of the Universal Declaration of Human Rights.</li>
            <li>Foster free and quality education among children.</li>
            <li>Ensure the availability of basic necessities like food, shelter, and clothing to all Indians.</li>
            <li>Fight against discrimination of humans based on sex, caste, creed, religion, and more.</li>
            <li>Provide free legal aid to the needy people of India.</li>
            <li>Create awareness among youth about their fundamental duties.</li>
            <li>Rehabilitate direct and indirect victims of crime until they are financially and mentally restored to live a normal social life.</li>
            <li>Publish books and periodicals to spread awareness and knowledge related to Human Rights.</li>
          </ul>
        </div>
      )
    },
    {
      key: uuidv4(),
      tab: "vision",
      title: "Vision Statement",
      content: (
        <div className="card vision">
          <ul>
            <li>Provision of health, education, and employment opportunities in registered slums of India and spread a green revolution among slums to upgrade them into more sophisticated and hygienic dwellings, supporting the United Nations Sustainable Development Programme.</li>
            <li>Rehabilitation of victims of domestic violence, abandoned children, women, and elderly citizens.</li>
            <li>Serve as an information provider to government bodies regarding anti-social activities, domestic violence, and corrupt practices.</li>
            <li>Be instrumental in making permanent positive changes in society that enforce gender equality.</li>
          </ul>
        </div>
      )
    },
    {
      key: uuidv4(),
      tab: "rules",
      title: "Rules and Regulations",
      content: (
        <div className="card rules">
          <ul>
            <li>The unit/cell/committee are free to take up projects/programmes provided they adhere to the following guidelines:</li>
            <ul>
              <li>Programmes should not propagate religious or political viewpoints.</li>
              <li>Programs must avoid anti-social or anti-government activities.</li>
              <li>Unhealthy criticism of the government and its officials is not allowed.</li>
              <li>Programs should align with the objectives of the National Human Rights Federation.</li>
              <li>Cash donations for a specific programme must be used solely for that project.</li>
              <li>A receipt voucher must be provided for all donations.</li>
              <li>Receipt vouchers must be issued by the national committee.</li>
              <li>General cash donations are not allowed.</li>
              <li>Units must participate in national programmes when requested.</li>
              <li>Programme proposals must be sanctioned by the national president before execution.</li>
              <li>Half-yearly activity and financial reports must be submitted on time.</li>
            </ul>
            <li>Membership Rules:</li>
            <ul>
              <li>Membership applications must include a signed form, Aadhaar or PAN card photocopy, and two passport photos.</li>
              <li>Membership fees should be credited to the Federation's account, with proof sent to the national committee.</li>
              <li>Members wishing to form a unit must follow the hierarchy and submit the appropriate forms.</li>
            </ul>
          </ul>
        </div>
      )
    },
    {
      key: uuidv4(),
      tab: "mission",
      title: "Mission Statement",
      content: (
        <div className="card mission">
          <ul>
            <li>Provision of nutritional food and medical facilities to the needy.</li>
            <li>Provision of quality and free education to needy children.</li>
            <li>Fight for the cause of the third gender.</li>
          </ul>
          <p>The mission statement shall be updated and modified with time.</p>
        </div>
      )
    }
  ];

  const certifications = [
    { id: 1, image: certificate1 },
    { id: 2, image: certificate2 },
    { id: 3, image: certificate3 },
    { id: 4, image: certificate4 },
    { id: 5, image: certificate5 },
    { id: 6, image: certificate6 },
       
      ];

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

    const handleNext = () => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % certifications.length);
    };
  
    const handlePrev = () => {
      setActiveIndex((prevIndex) =>
        prevIndex === 0 ? certifications.length - 1 : prevIndex - 1
      );
    };
    useEffect(() => {
  
  
      const autoSlide = setInterval(() => {
        handleNext();
      }, 5000); // Change slides every 5 seconds
  
      return () => clearInterval(autoSlide); // Cleanup on component unmount
    }, []);

  return (
    <>
    <div className="about-us-container">
      <div className="tab-navigation">
        {InCards.map((card) => (
          <div
            key={card.key}
            className={`tab ${activeTab === card.tab ? "active" : ""}`}
            onClick={() => handleTabChange(card.tab)}
          >
            {card.title}
          </div>
        ))}
      </div>

      <div className="tab-content">
        {InCards
          .filter((card) => card.tab === activeTab)
          .map((card) => (
            <div key={card.key}>{card.content}</div>
          ))}
      </div>
    </div>
     <div
            style={{
              width: "100%",
              padding: "40px 5vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
              position: "relative",
              background: "#FEF6F3"
    
            }}
          >
            <div className="home-ninth-section">
              <div className="ninth-container" style={{
                width: '100%'
              }}>
                <div className="ninth-upper-container">
                  <h4>Our Certifications</h4>
                  <h2>Latest & Update</h2>
                
                </div>
              </div>
            </div>
    
            <div
              style={{
                display: "flex",
                gap: "20px",
                overflow: "hidden",
                width: "80%",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {certifications.slice(activeIndex, activeIndex + 3).map((blog) => (
                <motion.div
                  key={blog.id}
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5 }}
                  style={{
                    flex: "1",
                    minWidth: "280px",
                    maxWidth: "380px",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                    textAlign: "center",
                    background: "#fff",
                    paddingBottom: "20px",
                  }}
                 // onClick={() => handleBlogClick(blog.id)}
                >
                  <img
                    src={blog.image}
                    alt={blog.id}
                    style={{
                      width: "100%",
                      height: "250px",
                      objectFit: "cover",
                    }}
                  />
                  {/* <h3
                    style={{
                      fontSize: "1.5rem",
                      margin: "10px 0",
                      color: "#333",
                    }}
                  >
                    {blog.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "#666",
                      padding: "0 10px",
                    }}
                  >
                    {blog.description}
                  </p> */}
                </motion.div>
              ))}
            </div>
    
            {/* Custom Left Arrow */}
            <button
              onClick={handlePrev}
              style={{
                position: "absolute",
                left: "2vw",
                cursor: "pointer",
                background: "rgba(0, 0, 0, 0.3)",
                border: "none",
                padding: "10px",
                borderRadius: "50%",
                transition: "all 0.3s ease",
                display: activeIndex === 0 ? "none" : "block",
              }}
            >
              <FaArrowLeft size={30} color="#fff" />
            </button>
    
            {/* Custom Right Arrow */}
            <button
              onClick={handleNext}
              style={{
                position: "absolute",
                right: "2vw",
                cursor: "pointer",
                background: "rgba(0, 0, 0, 0.3)",
                border: "none",
                padding: "10px",
                borderRadius: "50%",
                transition: "all 0.3s ease",
                display: activeIndex + 3 >= certifications.length ? "none" : "block",
              }}
            >
              <FaArrowRight size={30} color="#fff" />
            </button>
          </div>
</>
    
  );
};

export default AboutUs;
